
import { defineComponent } from "vue";

export default defineComponent({
  mounted() {
    this.$emit("scrolltop");
  },    
});
